import { Endpoint } from '../endpoint';

import {
  CompactProjectChecklistResponse,
  ProjectChecklistId,
  ProjectChecklistResponse,
  ProjectChecklistRequest,
  ProjectChecklistStepResponse,
  ChecklistType,
} from '@business/entities/project';

export function fetchMarketingChecklists(type: ChecklistType) {
  return Endpoint.get<CompactProjectChecklistResponse[]>(`@gc/marketing-board/checklist?type=${type}`);
}

export function fetchMarketingChecklist(id: ProjectChecklistId) {
  return Endpoint.get<ProjectChecklistResponse>(`@gc/marketing-board/checklist/checklist/${id}`);
}

export function createMarketingChecklist(data: ProjectChecklistRequest) {
  return Endpoint.post<ProjectChecklistResponse>(`@gc/marketing-board/checklist`, { data });
}

export function updateMarketingChecklist(id: ProjectChecklistId, data: ProjectChecklistRequest) {
  return Endpoint.patch<ProjectChecklistResponse>(`@gc/marketing-board/checklist/${id}`, { data });
}

export function duplicateMarketingChecklist(id: ProjectChecklistId, data: ProjectChecklistRequest) {
  return Endpoint.post<ProjectChecklistResponse>(`@gc/marketing-board/checklist/duplicate/${id}`, { data });
}

export function deleteMarketingChecklist(tempId: ProjectChecklistId) {
  return Endpoint.delete<void>(`@gc/marketing-board/checklist/${tempId}`);
}

/** Section **/
export function createChecklistSection(id: ProjectChecklistId, name: string) {
  return Endpoint.post<void>(`@gc/marketing-board/checklist/section/${id}`, { data: { name } });
}

export function updateChecklistSection(id: number, name: string) {
  return Endpoint.patch<void>(`@gc/marketing-board/checklist/section/${id}`, { data: { name } });
}

export function deleteChecklistSection(id: number) {
  return Endpoint.delete<void>(`@gc/marketing-board/checklist/section/${id}`);
}

export function sortSections(ids: number[]) {
  return Endpoint.post<void>(`@gc/marketing-board/checklist/section-order`, { data: { ids } });
}

/** Step **/
export function createChecklistStep(id: number, data: Partial<ProjectChecklistStepResponse>) {
  return Endpoint.post<void>(`@gc/marketing-board/checklist/step/${id}`, { data });
}

export function updateChecklistStep(id: number, data: Partial<ProjectChecklistStepResponse>) {
  return Endpoint.patch<void>(`@gc/marketing-board/checklist/step/${id}`, { data });
}

export function deleteChecklistStep(id: number) {
  return Endpoint.delete<void>(`@gc/marketing-board/checklist/step/${id}`);
}

export function sortSectionSteps(sectionId: number, ids: number[]) {
  return Endpoint.post<void>(`@gc/marketing-board/checklist/step-order`, { data: { ids, sectionId } });
}

export function createOrUpdateTemplate(id: ProjectChecklistId, data: Partial<ProjectChecklistResponse>) {
  return Endpoint.post<ProjectChecklistResponse>(`@gc/marketing-board/checklist/create-or-update/${id}`, { data });
}
